import React, { useState, useRef, useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { collection, query, where, getDocs, doc, updateDoc, writeBatch, deleteDoc, addDoc } from "firebase/firestore";
import { firestore } from '../../firebase';
import { fetchGame } from '../../util/api/game';
import GameSummaryMobile from '../components/GameSummaryMobile';
import GameSummaryWithControlsMobile from '../components/GameSummaryWithControlsMobile';
import chessslogo from "../../images/chessslogo.png";
import { ChessSocialContext } from '../../util/ChessSocialContext';
import { isNativeApp } from '../../util/platformDetection';
import { cleanProfanity } from '../../util/filterProfanity';

// Game Controls Panel Component
const GameControlsPanel = ({ gameId, folders, onClose, onReorder, onMove, onDelete, allGames }) => {
  const game = allGames.find(g => g.gameId === gameId);
  if (!game) return null;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '15px',
      padding: '10px',
      backgroundColor: '#2a2a2a',
      borderRadius: '8px',
      border: '1px solid gold'
    }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <span style={{ color: 'gold', fontWeight: 'bold', fontSize: '16px' }}>
          Bookmark Order & Settings
        </span>
        <button
          onClick={onClose}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'white',
            fontSize: '18px',
            cursor: 'pointer',
            padding: '5px'
          }}
        >
          <i className="fa-solid fa-times"></i>
        </button>
      </div>

      {/* Controls Row - Simplified layout */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '15px'
      }}>
        {/* Reorder Left */}
        <button
          onClick={() => onReorder(gameId, game.folderName, 'left')}
          style={{
            background: 'rgba(255, 215, 0, 0.15)',
            border: 'none',
            borderRadius: '8px',
            color: 'gold',
            padding: '12px 16px',
            cursor: 'pointer',
            fontSize: '18px',
            minWidth: '50px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease'
          }}
          onMouseDown={(e) => {
            e.currentTarget.style.transform = 'scale(0.95)';
          }}
          onMouseUp={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          <i className="fa-solid fa-arrow-left"></i>
        </button>

        {/* Reorder Right */}
        <button
          onClick={() => onReorder(gameId, game.folderName, 'right')}
          style={{
            background: 'rgba(255, 215, 0, 0.15)',
            border: 'none',
            borderRadius: '8px',
            color: 'gold',
            padding: '12px 16px',
            cursor: 'pointer',
            fontSize: '18px',
            minWidth: '50px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease'
          }}
          onMouseDown={(e) => {
            e.currentTarget.style.transform = 'scale(0.95)';
          }}
          onMouseUp={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          <i className="fa-solid fa-arrow-right"></i>
        </button>

        {/* Move to Folder - Positioned with upward dropdown */}
        <div style={{ position: 'relative' }}>
          <select
            onChange={(e) => {
              if (e.target.value) {
                onMove(gameId, game.folderName, e.target.value);
                onClose();
              }
            }}
            style={{
              background: 'rgba(128, 128, 128, 0.1)',
              border: '1px solid #888',
              borderRadius: '22px',
              color: '#ccc',
              padding: '11px 14px',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: 'bold',
              minWidth: '100px',
              maxWidth: '110px',
              appearance: 'none',
              WebkitAppearance: 'none',
              MozAppearance: 'none',
              backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'11\' height=\'11\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%23CCCCCC\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3E%3Cpolyline points=\'18 15 12 9 6 15\'%3E%3C/polyline%3E%3C/svg%3E")',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              paddingRight: '32px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            <option value="">Move to...</option>
            {folders
              .filter(f => f.folderName !== game.folderName)
              .map(f => (
                <option key={f.folderName} value={f.folderName} style={{color: 'black'}}>
                  {f.isPrivate ? '🔒 ' : ''}{cleanProfanity(f.folderName)}
                </option>
              ))}
          </select>
        </div>

        {/* Delete */}
        <button
          onClick={() => {
            onDelete(gameId, game.folderName);
            onClose();
          }}
          style={{
            background: 'rgba(255, 51, 102, 0.15)',
            border: 'none',
            borderRadius: '8px',
            color: '#ff3366',
            padding: '12px 16px',
            cursor: 'pointer',
            fontSize: '18px',
            minWidth: '50px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease'
          }}
          onMouseDown={(e) => {
            e.currentTarget.style.transform = 'scale(0.95)';
          }}
          onMouseUp={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
          }}
        >
          <i className="fa-solid fa-trash"></i>
        </button>
      </div>
    </div>
  );
};

const MobileBookmarks = ({ user }) => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState('public');
  const defaultFolders = [
    { folderName: 'Featured', isPrivate: false, games: [] },
    { folderName: 'Safe', isPrivate: true, games: [] }
  ];
  const [folders, setFolders] = useState(defaultFolders);
  const [expandedFolder, setExpandedFolder] = useState(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [folderToToggle, setFolderToToggle] = useState(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [gameToDelete, setGameToDelete] = useState(null);
  const [showNewFolderInput, setShowNewFolderInput] = useState(false);
  const [newFolderName, setNewFolderName] = useState('');
  const [newFolderPrivate, setNewFolderPrivate] = useState(false);
  const [showFolderDeleteDialog, setShowFolderDeleteDialog] = useState(false);
  const [folderToDelete, setFolderToDelete] = useState(null);
  const [notification, setNotification] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [gamesData, setGamesData] = useState([]);
  const [error, setError] = useState(null);
  const [activeGameControls, setActiveGameControls] = useState(null); // Track which game has controls open
  const { isSidebarCollapsed } = useContext(ChessSocialContext);

  // Fetch data when component mounts
  useEffect(() => {
    getData();
  }, [user]);

  const getData = async () => {
    try {
      setIsLoading(true);
      setError(null);

      if (!user || !user.credentials || !user.credentials.userId) {
        setError('You must be logged in to view bookmarks');
        setIsLoading(false);
        return;
      }

      const userId = user.credentials.userId;

      // Fetch bookmark folders for the current user
      const folderQuery = query(
        collection(firestore, "bookmarkFolders"),
        where("userId", "==", userId)
      );

      const folderSnapshot = await getDocs(folderQuery);

      let fetchedFolders = [];

      if (!folderSnapshot.empty) {
        fetchedFolders = folderSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          folderIndex: doc.data().folderIndex !== undefined ? doc.data().folderIndex : 999
        }));
      }

      // Ensure default folders exist
      let mergedFolders = [...fetchedFolders];

      // Check if Featured folder exists, if not add it
      if (!fetchedFolders.some(folder => folder.folderName === 'Featured')) {
        mergedFolders.push({
          folderName: 'Featured',
          isPrivate: false,
          games: [],
          userId: userId,
          folderIndex: 0
        });
      } else {
        mergedFolders = mergedFolders.map(folder =>
          folder.folderName === 'Featured' ? { ...folder, folderIndex: 0 } : folder
        );
      }

      // Check if Safe folder exists, if not add it
      if (!fetchedFolders.some(folder => folder.folderName === 'Safe')) {
        mergedFolders.push({
          folderName: 'Safe',
          isPrivate: true,
          games: [],
          userId: userId,
          folderIndex: 0
        });
      } else {
        mergedFolders = mergedFolders.map(folder =>
          folder.folderName === 'Safe' ? { ...folder, folderIndex: 0 } : folder
        );
      }

      // Sort folders by folderIndex within their privacy category
      mergedFolders.sort((a, b) => {
        if (a.isPrivate !== b.isPrivate) {
          return a.isPrivate ? 1 : -1;
        }
        return a.folderIndex - b.folderIndex;
      });

      setFolders(mergedFolders);

      // Fetch game details for all bookmarked games
      const gameIds = new Set();
      mergedFolders.forEach(folder => {
        if (folder.games && Array.isArray(folder.games)) {
          folder.games.forEach(game => {
            gameIds.add(game.gameId);
          });
        }
      });

      if (gameIds.size > 0) {
        await fetchBatchData(Array.from(gameIds));
      }

      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching bookmarks:', error);
      setError('Failed to load bookmarks. Please try again.');
      setIsLoading(false);
    }
  };

  const fetchBatchData = async (gameIds) => {
    if (!gameIds || gameIds.length === 0) return;

    try {
      const gamePromises = gameIds.map(gameId => fetchGame(gameId));
      const gameResults = await Promise.allSettled(gamePromises);

      const successfulGames = gameResults
        .filter(result => result.status === 'fulfilled')
        .map(result => result.value);

      setGamesData(successfulGames);
    } catch (error) {
      console.error('Error fetching game data:', error);
    }
  };

  const showNotification = (message, type = 'success') => {
    setNotification({
      message,
      type
    });

    setTimeout(() => {
      setNotification(null);
    }, 3000);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setActiveGameControls(null); // Clear selected game when switching tabs
  };

  const toggleFolderExpand = (folderName) => {
    if (expandedFolder === folderName) {
      setExpandedFolder(null);
    } else {
      setExpandedFolder(folderName);
    }
    setActiveGameControls(null); // Clear selected game when expanding/collapsing folders
  };

  const toggleFolderPrivacy = async (folderName) => {
    if (folderName === 'Featured' || folderName === 'Safe') {
      showNotification("Cannot change privacy settings for default folders", "error");
      return;
    }

    const folder = folders.find(f => f.folderName === folderName);
    if (!folder) return;

    if (folder.isPrivate) {
      setFolderToToggle(folderName);
      setShowConfirmDialog(true);
    } else {
      try {
        const folderRef = query(
          collection(firestore, "bookmarkFolders"),
          where("userId", "==", user.credentials.userId),
          where("folderName", "==", folderName)
        );

        const snapshot = await getDocs(folderRef);
        if (!snapshot.empty) {
          const docRef = snapshot.docs[0].ref;
          const privateMaxIndex = Math.max(
            ...folders
              .filter(f => f.isPrivate && f.folderName !== 'Safe')
              .map(f => f.folderIndex),
            0
          );

          await updateDoc(docRef, {
            isPrivate: true,
            folderIndex: privateMaxIndex + 1
          });

          setFolders(folders.map(f =>
            f.folderName === folderName ? { ...f, isPrivate: true, folderIndex: privateMaxIndex + 1 } : f
          ));

          showNotification(`Folder "${folderName}" is now private`);
        }
      } catch (error) {
        console.error("Error updating folder privacy:", error);
        showNotification("Failed to update folder privacy", "error");
      }
    }
  };

  const confirmMakePublic = async () => {
    if (folderToToggle) {
      try {
        const publicMaxIndex = Math.max(
          ...folders
            .filter(f => !f.isPrivate && f.folderName !== 'Featured')
            .map(f => f.folderIndex),
          0
        );

        const folderRef = query(
          collection(firestore, "bookmarkFolders"),
          where("userId", "==", user.credentials.userId),
          where("folderName", "==", folderToToggle)
        );

        const snapshot = await getDocs(folderRef);
        if (!snapshot.empty) {
          const docRef = snapshot.docs[0].ref;

          await updateDoc(docRef, {
            isPrivate: false,
            folderIndex: publicMaxIndex + 1
          });

          setFolders(folders.map(folder =>
            folder.folderName === folderToToggle
              ? { ...folder, isPrivate: false, folderIndex: publicMaxIndex + 1 }
              : folder
          ));

          showNotification(`Folder "${folderToToggle}" is now public`);
          setActiveTab('public'); // Switch to public tab
        }
      } catch (error) {
        console.error("Error updating folder privacy:", error);
        showNotification("Failed to update folder privacy", "error");
      }

      setFolderToToggle(null);
    }
    setShowConfirmDialog(false);
  };

  const cancelMakePublic = () => {
    setFolderToToggle(null);
    setShowConfirmDialog(false);
  };

  const handleCreateFolder = async () => {
    if (!newFolderName.trim()) {
      showNotification("Please enter a folder name", "error");
      return;
    }

    if (folders.some(folder => folder.folderName === newFolderName.trim())) {
      showNotification("A folder with this name already exists", "error");
      return;
    }

    setActiveGameControls(null); // Clear selected game when creating new folder

    const emptyFolderCount = folders.filter(folder =>
      folder.games.length === 0 &&
      folder.folderName !== 'Featured' &&
      folder.folderName !== 'Safe'
    ).length;

    if (emptyFolderCount >= 3) {
      showNotification("You can only have up to 3 empty folders", "error");
      return;
    }

    try {
      const isPrivate = newFolderPrivate;
      const maxIndex = Math.max(
        ...folders
          .filter(f => f.isPrivate === isPrivate &&
            (f.folderName !== 'Featured' && f.folderName !== 'Safe'))
          .map(f => f.folderIndex),
        0
      );

      const newFolder = {
        userId: user.credentials.userId,
        folderName: newFolderName.trim(),
        isPrivate: newFolderPrivate,
        games: [],
        createdAt: new Date().toISOString(),
        folderIndex: maxIndex + 1
      };

      const docRef = await addDoc(collection(firestore, "bookmarkFolders"), newFolder);

      setFolders([...folders, {
        id: docRef.id,
        folderName: newFolderName.trim(),
        isPrivate: newFolderPrivate,
        games: [],
        folderIndex: maxIndex + 1
      }]);

      showNotification(`Folder "${newFolderName.trim()}" created successfully`);
      setNewFolderName("");
      setNewFolderPrivate(false);
      setShowNewFolderInput(false);
    } catch (error) {
      console.error("Error creating folder:", error);
      showNotification("Failed to create folder", "error");
    }
  };

  const handleDeleteFolder = (folderName) => {
    setFolderToDelete(folderName);
    setShowFolderDeleteDialog(true);
  };

  const confirmDeleteFolder = async () => {
    if (folderToDelete) {
      try {
        const folder = folders.find(f => f.folderName === folderToDelete);

        if (folderToDelete === 'Featured' || folderToDelete === 'Safe') {
          showNotification(`Cannot delete default folder "${folderToDelete}"`, 'error');
          setFolderToDelete(null);
          setShowFolderDeleteDialog(false);
          return;
        }

        if (folder && folder.id) {
          const folderRef = doc(firestore, "bookmarkFolders", folder.id);
          await deleteDoc(folderRef);
        }

        const updatedFolders = folders.filter(folder => folder.folderName !== folderToDelete);
        setFolders(updatedFolders);

        showNotification(`Folder "${folderToDelete}" has been deleted`);
        setFolderToDelete(null);
      } catch (error) {
        console.error('Error deleting folder:', error);
        showNotification('Failed to delete folder. Please try again.', 'error');
      }
    }
    setShowFolderDeleteDialog(false);
  };

  const cancelDeleteFolder = () => {
    setFolderToDelete(null);
    setShowFolderDeleteDialog(false);
  };

  const handleDeleteGame = async (gameId, folderName) => {
    setGameToDelete({ gameId, folderName });
    setShowDeleteDialog(true);
  };

  const confirmDeleteGame = async () => {
    try {
      const { gameId, folderName } = gameToDelete;
      const folder = folders.find(f => f.folderName === folderName);
      if (!folder) return;

      const gameIndex = folder.games.findIndex(g => g.gameId === gameId);
      if (gameIndex === -1) return;

      const game = folder.games[gameIndex];
      const updatedGames = [...folder.games];
      updatedGames.splice(gameIndex, 1);

      updatedGames.forEach(g => {
        if (g.index > game.index) {
          g.index -= 1;
        }
      });

      if (folder.id) {
        const folderRef = doc(firestore, "bookmarkFolders", folder.id);
        await updateDoc(folderRef, {
          games: updatedGames,
          updatedAt: new Date().toISOString()
        });
      }

      const updatedFolders = folders.map(f => {
        if (f.folderName === folderName) {
          return { ...f, games: updatedGames };
        }
        return f;
      });

      setFolders(updatedFolders);
      showNotification(`Game removed from folder "${folderName}"`);
      setShowDeleteDialog(false);
    } catch (error) {
      console.error('Error deleting game:', error);
      showNotification('Failed to delete game. Please try again.', 'error');
      setShowDeleteDialog(false);
    }
  };

  const cancelDeleteGame = () => {
    setGameToDelete(null);
    setShowDeleteDialog(false);
  };

  // Game reordering function - adapted from web version
  const reorderGames = async (gameId, folderName, direction) => {
    try {
      setIsLoading(true);

      // Find the folder in our state by folderName
      const folder = folders.find(f => f.folderName === folderName);

      if (!folder) {
        console.error(`Folder "${folderName}" not found`);
        showNotification(`Folder not found`, 'error');
        setIsLoading(false);
        return;
      }

      // Find the game in the folder
      const games = folder.games || [];
      const gameIndex = games.findIndex(g => g.gameId === gameId);

      if (gameIndex === -1) {
        console.error(`Game ${gameId} not found in folder ${folderName}`);
        showNotification(`Game not found in folder`, 'error');
        setIsLoading(false);
        return;
      }

      // Calculate new index based on direction
      const newIndex = direction === 'left' ? gameIndex - 1 : gameIndex + 1;

      // Check if new index is valid
      if (newIndex < 0 || newIndex >= games.length) {
        setIsLoading(false);
        return;
      }

      // Get the Firestore document reference
      const folderQuery = query(
        collection(firestore, "bookmarkFolders"),
        where("userId", "==", user.credentials.userId),
        where("folderName", "==", folderName)
      );

      const folderSnapshot = await getDocs(folderQuery);

      if (folderSnapshot.empty) {
        console.error(`Folder "${folderName}" not found in database`);
        showNotification(`Folder not found in database`, 'error');
        setIsLoading(false);
        return;
      }

      const folderDoc = folderSnapshot.docs[0];
      const folderData = folderDoc.data();

      // Get the games array from Firestore
      const firestoreGames = folderData.games || [];

      // Sort the games by index to ensure correct order
      firestoreGames.sort((a, b) => a.index - b.index);

      // Find the game to move and the game to swap with
      const gameToMoveIndex = firestoreGames.findIndex(g => g.gameId === gameId);

      if (gameToMoveIndex === -1) {
        console.error(`Game ${gameId} not found in folder ${folderName} in database`);
        showNotification(`Game not found in database`, 'error');
        setIsLoading(false);
        return;
      }

      // Calculate new index in the database
      const newDbIndex = direction === 'left' ? gameToMoveIndex - 1 : gameToMoveIndex + 1;

      // Check if new index is valid
      if (newDbIndex < 0 || newDbIndex >= firestoreGames.length) {
        setIsLoading(false);
        return;
      }

      // Get the two games that will swap positions
      const gameToMove = firestoreGames[gameToMoveIndex];
      const gameToSwap = firestoreGames[newDbIndex];

      // Swap their indices
      const tempIndex = gameToMove.index;
      gameToMove.index = gameToSwap.index;
      gameToSwap.index = tempIndex;

      // Update the database
      await updateDoc(folderDoc.ref, {
        games: firestoreGames,
        updatedAt: new Date().toISOString()
      });

      // Create a deep copy of the folders array
      const updatedFolders = JSON.parse(JSON.stringify(folders));

      // Find the folder to update
      const folderToUpdateIndex = updatedFolders.findIndex(f => f.folderName === folderName);

      if (folderToUpdateIndex !== -1) {
        // Get the games array from the folder
        const updatedGames = updatedFolders[folderToUpdateIndex].games || [];

        // Find the indices of the games to swap in the local state
        const localGameToMoveIndex = updatedGames.findIndex(g => g.gameId === gameId);
        const localGameToSwapIndex = direction === 'left' ? localGameToMoveIndex - 1 : localGameToMoveIndex + 1;

        if (localGameToMoveIndex !== -1 && localGameToSwapIndex >= 0 && localGameToSwapIndex < updatedGames.length) {
          // Swap the games in the local state
          const temp = updatedGames[localGameToMoveIndex];
          updatedGames[localGameToMoveIndex] = updatedGames[localGameToSwapIndex];
          updatedGames[localGameToSwapIndex] = temp;

          // Update the indices to match their new positions
          updatedGames.forEach((game, idx) => {
            game.index = idx;
          });

          // Update the folder with the new games array
          updatedFolders[folderToUpdateIndex].games = updatedGames;

          // Update the state
          setFolders(updatedFolders);
        }
      }

      showNotification(`Game reordered successfully`);

    } catch (error) {
      console.error("Error reordering game:", error);
      showNotification(`Error reordering game: ${error.message}`, 'error');
    } finally {
      setIsLoading(false);
    }
  };

  // Move game to different folder function - adapted from web version
  const moveGameToFolder = async (gameId, sourceFolder, targetFolder) => {
    try {
      setIsLoading(true);

      // Find the source folder
      const sourceFolderDoc = folders.find(f => f.folderName === sourceFolder);
      if (!sourceFolderDoc) {
        console.error(`Source folder "${sourceFolder}" not found`);
        return;
      }

      // Find the target folder
      const targetFolderDoc = folders.find(f => f.folderName === targetFolder);
      if (!targetFolderDoc) {
        console.error(`Target folder "${targetFolder}" not found`);
        return;
      }

      // Find the game in the source folder
      const gameIndex = sourceFolderDoc.games.findIndex(g => g.gameId === gameId);
      if (gameIndex === -1) {
        console.error(`Game ${gameId} not found in folder ${sourceFolder}`);
        return;
      }

      const game = sourceFolderDoc.games[gameIndex];

      // Remove the game from the source folder
      const updatedSourceGames = [...sourceFolderDoc.games];
      updatedSourceGames.splice(gameIndex, 1);

      // Reindex the source folder games
      updatedSourceGames.forEach(g => {
        if (g.index > game.index) {
          g.index -= 1;
        }
      });

      // Add the game to the target folder at index 0
      const updatedTargetGames = [...(Array.isArray(targetFolderDoc.games) ? targetFolderDoc.games : [])];

      // Increment all indexes in the target folder
      updatedTargetGames.forEach(g => {
        g.index += 1;
      });

      // Add the game at index 0
      updatedTargetGames.unshift({
        ...game,
        index: 0,
        createdAt: new Date().toISOString()
      });

      // Use a batch for database operations
      const batch = writeBatch(firestore);

      // Update source folder in Firestore
      const sourceFolderRef = doc(firestore, "bookmarkFolders", sourceFolderDoc.id);
      batch.update(sourceFolderRef, {
        games: updatedSourceGames,
        updatedAt: new Date().toISOString()
      });

      // Check if target folder exists in the database
      let targetFolderRef;

      if (!targetFolderDoc.id) {
        // Target folder doesn't exist in the database yet (empty Featured or Safe folders)
        const folderIndex = (targetFolder === 'Featured' || targetFolder === 'Safe') ? 0 : 1;

        // Create new folder document data
        const newFolderData = {
          userId: user.credentials.userId,
          folderName: targetFolder,
          isPrivate: targetFolder === 'Safe',
          games: updatedTargetGames,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          folderIndex: folderIndex
        };

        // Add the new folder document to Firestore
        const newFolderRef = doc(collection(firestore, "bookmarkFolders"));
        batch.set(newFolderRef, newFolderData);

        targetFolderRef = newFolderRef;
        targetFolderDoc.id = newFolderRef.id;
      } else {
        // Target folder already exists in the database
        targetFolderRef = doc(firestore, "bookmarkFolders", targetFolderDoc.id);
        batch.update(targetFolderRef, {
          games: updatedTargetGames,
          updatedAt: new Date().toISOString()
        });
      }

      // Commit the batch operation
      await batch.commit();

      // Update local state
      const updatedFolders = folders.map(f => {
        if (f.id === sourceFolderDoc.id) {
          return { ...f, games: updatedSourceGames };
        }
        if (f.folderName === targetFolderDoc.folderName) {
          return {
            ...f,
            id: targetFolderDoc.id || targetFolderRef.id,
            games: updatedTargetGames
          };
        }
        return f;
      });

      setFolders(updatedFolders);
      showNotification(`Game moved from "${sourceFolder}" to "${targetFolder}"`);
    } catch (error) {
      console.error('Error moving game to folder:', error);
      showNotification('Failed to move game. Please try again.', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  // Folder reordering function - adapted from web version
  const changeFolderIndex = async (folderName, direction) => {
    setIsLoading(true);
    try {
      // Find the folder
      const folder = folders.find(f => f.folderName === folderName);
      if (!folder) {
        console.error(`Folder "${folderName}" not found`);
        setIsLoading(false);
        return;
      }

      // Don't allow reordering default folders
      if (folderName === 'Featured' || folderName === 'Safe') {
        showNotification("Cannot reorder default folders", "error");
        setIsLoading(false);
        return;
      }

      // Get all folders in the same privacy category
      const categoryFolders = folders.filter(f =>
        f.isPrivate === folder.isPrivate &&
        f.folderName !== 'Featured' &&
        f.folderName !== 'Safe'
      );

      // Sort by folderIndex
      categoryFolders.sort((a, b) => a.folderIndex - b.folderIndex);

      // Find the current folder's position in the sorted list
      const currentPosition = categoryFolders.findIndex(f => f.folderName === folderName);

      // Calculate the target position
      const targetPosition = direction === 'up' ? currentPosition - 1 : currentPosition + 1;

      // Check if the target position is valid
      if (targetPosition < 0 || targetPosition >= categoryFolders.length) {
        setIsLoading(false);
        return;
      }

      // Get the target folder
      const targetFolder = categoryFolders[targetPosition];

      // Swap indexes
      const currentIndex = folder.folderIndex;
      const targetIndex = targetFolder.folderIndex;

      // Apply immediate UI update first
      const updatedFolders = JSON.parse(JSON.stringify(folders)).map(f => {
        if (f.folderName === folderName) {
          return { ...f, folderIndex: targetIndex };
        }
        if (f.folderName === targetFolder.folderName) {
          return { ...f, folderIndex: currentIndex };
        }
        return f;
      });

      // Update local state immediately
      setFolders(updatedFolders);

      // Show notification immediately
      showNotification(`Folder "${folderName}" moved ${direction}`);

      // Update in Firestore using a batch
      const batch = writeBatch(firestore);

      // Update current folder
      const currentFolderRef = doc(firestore, "bookmarkFolders", folder.id);
      batch.update(currentFolderRef, { folderIndex: targetIndex });

      // Update target folder
      const targetFolderRef = doc(firestore, "bookmarkFolders", targetFolder.id);
      batch.update(targetFolderRef, { folderIndex: currentIndex });

      // Commit the batch
      await batch.commit();

      setIsLoading(false);
    } catch (error) {
      console.error('Error reordering folders:', error);
      showNotification('Failed to reorder folders. Please try again.', 'error');

      // If error occurs, refresh the data to restore the correct order
      getData();
      setIsLoading(false);
    }
  };

  // Filter folders based on active tab
  const filteredFolders = folders
    .filter(folder =>
      (activeTab === 'public' && !folder.isPrivate) ||
      (activeTab === 'private' && folder.isPrivate)
    )
    .sort((a, b) => {
      if (a.folderName === 'Featured' || a.folderName === 'Safe') return -1;
      if (b.folderName === 'Featured' || b.folderName === 'Safe') return 1;
      return a.folderIndex - b.folderIndex;
    });

  return (
    <div style={{
      width: '100vw',
      height: 'calc(100dvh - 55px)', // Account for bottom navigation
      backgroundColor: '#1a1a1a',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      paddingTop: 'env(safe-area-inset-top)', // iPhone notch safe area
      paddingBottom: 'env(safe-area-inset-bottom)' // iPhone gesture area
    }}>
      
      {/* Header */}
      <div style={{
        backgroundColor: '#1a1a1a',
        borderBottom: '1px solid #333',
        padding: '12px 20px',
       position: 'relative',
      
        flexShrink: 0
      }}>
         <h3 style={{ 
          color: 'gold', 
          margin: 0, 
          fontSize: '18px',
          textAlign: 'center',
          fontWeight: 'bold' 
        }}>
          Bookmarks
        </h3>
        <button
          onClick={() => history.push(`/profile/${user?.credentials?.handle}`)}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            color: '#888',
            fontSize: '14px',
            cursor: 'pointer',
            padding: '0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            position: 'absolute',
            left: '5%',
            top: '40%'
          }}
        >
          <i className="fa-solid fa-arrow-left" style={{ fontSize: '16px' }}></i>
        </button>
       
        <div style={{ width: '80px' }}></div> {/* Spacer for centering */}
      </div>

      {/* Loading overlay */}
      {isLoading && (
        <div style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 9999,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          padding: '20px',
          borderRadius: '10px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <img
            src={chessslogo}
            alt="Loading bookmarks"
            style={{
              width: '60px',
              height: 'auto',
              animation: 'spin 2s linear infinite'
            }}
          />
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
          
        </div>
      )}

      {/* Notification */}
      {notification && (
        <div style={{
          position: "fixed",
          top: isNativeApp() ? "calc(50% + 30px)" : "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
          color: notification.type === 'error' ? '#ff3366' : '#58b047',
          padding: '12px 20px',
          borderRadius: '8px',
          zIndex: '1001',
          fontSize: '14px',
          fontWeight: 'bold',
          textAlign: 'center',
          maxWidth: '80%',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)'
        }}>
          {notification.message}
        </div>
      )}

      {/* Confirmation Dialog for making a folder public */}
      {showConfirmDialog && (
        <div style={{
          position: "fixed",
          top: "0",
          left: "0",
          right: "0",
          bottom: "0",
          backgroundColor: 'rgba(0,0,0,0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1002,
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: '#1a1a1a',
            border: '2px solid gold',
            borderRadius: '8px',
            padding: '20px',
            maxWidth: '400px',
            width: '100%'
          }}>
            <h3 style={{ color: 'gold', marginTop: 0, fontSize: '18px' }}>Make Folder Public?</h3>
            <p style={{ color: 'white', marginBottom: '20px', fontSize: '14px', lineHeight: '1.4' }}>
              Making this folder public will allow all users to see its contents. Are you sure you want to continue?
            </p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button
                onClick={cancelMakePublic}
                style={{
                  padding: '10px 16px',
                  backgroundColor: 'transparent',
                  color: 'white',
                  border: '1px solid white',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmMakePublic}
                style={{
                  padding: '10px 16px',
                  backgroundColor: 'gold',
                  color: 'black',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '14px'
                }}
              >
                Make Public
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Dialog for deleting a folder */}
      {showFolderDeleteDialog && (
        <div style={{
          position: "fixed",
          top: "0",
          left: "0",
          right: "0",
          bottom: "0",
          backgroundColor: 'rgba(0,0,0,0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1002,
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: '#1a1a1a',
            border: '2px solid #ff4d4d',
            borderRadius: '8px',
            padding: '20px',
            maxWidth: '400px',
            width: '100%'
          }}>
            <h3 style={{ color: '#ff4d4d', marginTop: 0, fontSize: '18px' }}>Delete Folder?</h3>
            <p style={{ color: 'white', marginBottom: '20px', fontSize: '14px', lineHeight: '1.4' }}>
              Are you sure you want to delete this folder and all its contents? This action cannot be undone.
            </p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button
                onClick={cancelDeleteFolder}
                style={{
                  padding: '10px 16px',
                  backgroundColor: 'transparent',
                  color: 'white',
                  border: '1px solid white',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmDeleteFolder}
                style={{
                  padding: '10px 16px',
                  backgroundColor: '#ff4d4d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '14px'
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Dialog for deleting a game */}
      {showDeleteDialog && (
        <div style={{
          position: "fixed",
          top: "0",
          left: "0",
          right: "0",
          bottom: "0",
          backgroundColor: 'rgba(0,0,0,0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1002,
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: '#1a1a1a',
            border: '2px solid #ff4d4d',
            borderRadius: '8px',
            padding: '20px',
            maxWidth: '400px',
            width: '100%'
          }}>
            <h3 style={{ color: '#ff4d4d', marginTop: 0, fontSize: '18px' }}>Delete Game?</h3>
            <p style={{ color: 'white', marginBottom: '20px', fontSize: '14px', lineHeight: '1.4' }}>
              Are you sure you want to remove this game from the folder? This action cannot be undone.
            </p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button
                onClick={cancelDeleteGame}
                style={{
                  padding: '10px 16px',
                  backgroundColor: 'transparent',
                  color: 'white',
                  border: '1px solid white',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmDeleteGame}
                style={{
                  padding: '10px 16px',
                  backgroundColor: '#ff4d4d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '14px'
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Tab Navigation */}
      <div style={{
        display: 'flex',
        backgroundColor: '#1a1a1a',
        borderBottom: '1px solid #333'
      }}>
        <button
          onClick={() => handleTabClick('public')}
          style={{
            flex: 1,
            padding: '16px',
            border: 'none',
            backgroundColor: activeTab === 'public' ? '#333' : 'transparent',
            color: activeTab === 'public' ? 'gold' : '#888',
            fontSize: '16px',
            fontWeight: 'bold',
            borderBottom: activeTab === 'public' ? '3px solid gold' : '3px solid transparent'
          }}
        >
          Public Folders
        </button>
        <button
          onClick={() => handleTabClick('private')}
          style={{
            flex: 1,
            padding: '16px',
            border: 'none',
            backgroundColor: activeTab === 'private' ? '#333' : 'transparent',
            color: activeTab === 'private' ? 'gold' : '#888',
            fontSize: '16px',
            fontWeight: 'bold',
            borderBottom: activeTab === 'private' ? '3px solid gold' : '3px solid transparent'
          }}
        >
          Private Folders
        </button>
      </div>

      {/* Main Content Area */}
      <div style={{
        flex: 1,
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        padding: '10px',
        minHeight: 0 // Allow flex child to shrink
      }}>
        {filteredFolders.length === 0 ? (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            color: '#666',
            textAlign: 'center'
          }}>
            <i className="fa-solid fa-bookmark" style={{ fontSize: '48px', marginBottom: '20px' }}></i>
            <h3 style={{ color: '#888', marginBottom: '10px' }}>No {activeTab} folders</h3>
            <p style={{ color: '#666', fontSize: '14px', maxWidth: '250px' }}>
              Create folders to organize your bookmarked games.
            </p>
          </div>
        ) : (
          filteredFolders.map((folder) => {
            // Sort games by index
            const sortedGames = folder.games && Array.isArray(folder.games)
              ? [...folder.games].sort((a, b) => a.index - b.index)
              : [];

            // Map game IDs to full game data
            const allGames = sortedGames.map(game => {
              const gameData = gamesData.find(g => g && g.id === game.gameId);
              return gameData ? { ...game, ...gameData } : null;
            }).filter(game => game !== null);

            return (
              <div
                key={folder.folderName || folder.id}
                style={{
                  marginBottom: '15px',
                  backgroundColor: '#1a1a1a',
                  borderRadius: '8px',
                  border: '1px solid #333',
                  overflow: 'hidden'
                }}
              >
                {/* Folder Header */}
                <div
                  onClick={() => toggleFolderExpand(folder.folderName)}
                  style={{
                    padding: '15px',
                    backgroundColor: '#2a2a2a',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                    borderBottom: '1px solid #333'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                    <i
                      className={expandedFolder === folder.folderName ? "fa-solid fa-folder-open" : "fa-solid fa-folder"}
                      style={{ marginRight: '10px', color: 'gold', fontSize: '20px' }}
                    ></i>
                    <span style={{ fontSize: '16px', fontWeight: 'bold', color: 'white' }}>
                      {cleanProfanity(folder.folderName)}
                    </span>
                    <span style={{ marginLeft: '8px', color: '#aaa', fontSize: '12px' }}>
                      ({allGames.length} games)
                    </span>
                  </div>

                  {/* Folder Management Controls */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginRight: '10px' }}>
                    {/* Privacy toggle - functional for custom folders */}
                    {folder.folderName !== 'Featured' && folder.folderName !== 'Safe' && (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleFolderPrivacy(folder.folderName);
                        }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          cursor: 'pointer',
                          padding: '5px'
                        }}
                      >
                        <i 
                          className={folder.isPrivate ? "fa-solid fa-eye-slash" : "fa-solid fa-eye"}
                          style={{ 
                            color: folder.isPrivate ? '#ff6b6b' : '#4ecdc4', 
                            fontSize: '16px' 
                          }}
                          title={folder.isPrivate ? 'Make Public' : 'Make Private'}
                        ></i>
                      </div>
                    )}

                    {/* Disabled privacy icon for Safe folder */}
                    {folder.folderName === 'Safe' && (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '5px',
                          cursor: 'not-allowed'
                        }}
                      >
                        <i 
                          className="fa-solid fa-eye-slash"
                          style={{ 
                            color: '#666', 
                            fontSize: '16px' 
                          }}
                          title="Safe folder is always private"
                        ></i>
                      </div>
                    )}

                    {/* Delete folder - functional for custom folders */}
                    {folder.folderName !== 'Featured' && folder.folderName !== 'Safe' && (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteFolder(folder.folderName);
                        }}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          cursor: 'pointer',
                          padding: '5px'
                        }}
                      >
                        <i 
                          className="fa-solid fa-trash"
                          style={{ 
                            color: '#ff6b6b', 
                            fontSize: '14px' 
                          }}
                          title="Delete Folder"
                        ></i>
                      </div>
                    )}

                    {/* Disabled delete icon for Safe folder */}
                    {folder.folderName === 'Safe' && (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '5px',
                          cursor: 'not-allowed'
                        }}
                      >
                        <i 
                          className="fa-solid fa-trash"
                          style={{ 
                            color: '#666', 
                            fontSize: '14px' 
                          }}
                          title="Safe folder cannot be deleted"
                        ></i>
                      </div>
                    )}
                  </div>

                  <i
                    className={expandedFolder === folder.folderName ? "fa-solid fa-chevron-up" : "fa-solid fa-chevron-down"}
                    style={{ color: '#ddd', fontSize: '14px' }}
                  ></i>
                </div>

                {/* Games Grid */}
                {expandedFolder === folder.folderName && (
                  <div style={{
                    padding: '10px'
                  }}>
                    {allGames.length === 0 ? (
                      <div style={{ 
                        padding: '20px', 
                        color: '#aaa', 
                        fontStyle: 'italic',
                        textAlign: 'center'
                      }}>
                        No games in this folder yet.
                      </div>
                    ) : (
                      <div style={{ 
                        overflowX: 'auto',
                        overflowY: 'visible', // Changed from hidden to visible to show ellipsis buttons
                        WebkitOverflowScrolling: 'touch',
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                        paddingBottom: 'calc(env(safe-area-inset-bottom) + 20px)' // Extra space for ellipsis buttons
                      }}>
                        <div style={{ 
                          display: 'flex',
                          gap: '15px',
                          paddingTop: '10px',
                          paddingBottom: 'calc(env(safe-area-inset-bottom) + 20px)'
                        }}>
                          {allGames.map((game, gameIndex) => (
                            <div key={game.gameId} style={{ 
                              flexShrink: 0,
                              width: '160px', // Increased from 120px
                              position: 'relative',
                              overflow: 'visible' // Allow ellipsis button to extend beyond container
                            }}>
                              <GameSummaryWithControlsMobile
                                game={{
                                  gameId: game.gameId,
                                  creatorHandle: game.creatorHandle,
                                  caption: game.caption,
                                  tags: game.tags || [],
                                  moves: typeof game.moves === 'string' ? 
                                    (function() {
                                      try {
                                        return JSON.parse(game.moves);
                                      } catch (e) {
                                        return [];
                                      }
                                    })() : (Array.isArray(game.moves) ? game.moves : [])
                                }}
                                folderName={folder.folderName}
                                folders={folders}
                                onDelete={handleDeleteGame}
                                onReorder={(gameId, folderName, direction) => reorderGames(gameId, folderName, direction)}
                                onMove={(gameId, fromFolder, toFolder) => moveGameToFolder(gameId, fromFolder, toFolder)}
                                gameIndex={gameIndex}
                                showControls={activeGameControls === game.gameId}
                                onToggleControls={(gameId) => {
                                  setActiveGameControls(activeGameControls === gameId ? null : gameId);
                                }}
                                allGamesInFolder={allGames}
                              />
                            </div>
                          ))}
                        </div>
                        <style jsx>{`
                          div::-webkit-scrollbar {
                            display: none;
                          }
                        `}</style>
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>

      {/* Create New Folder Section OR Game Controls */}
      <div style={{
        borderTop: '1px solid #333',
        backgroundColor: '#1a1a1a',
        padding: '15px',
        paddingBottom: '80px', // Extra padding to keep content above CREATE NEW FOLDER button

        flexShrink: 0 // Prevent this section from shrinking
      }}>
        {activeGameControls ? (
          // Show game controls for the active game
          <GameControlsPanel 
            gameId={activeGameControls}
            folders={folders}
            onClose={() => setActiveGameControls(null)}
            onReorder={reorderGames}
            onMove={moveGameToFolder}
            onDelete={handleDeleteGame}
            allGames={filteredFolders.flatMap(folder => 
              folder.games.map(game => ({...game, folderName: folder.folderName}))
            )}
          />
        ) : showNewFolderInput ? (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px'
          }}>
            <input
              type="text"
              value={newFolderName}
              onChange={(e) => setNewFolderName(e.target.value)}
              placeholder="Enter folder name"
              style={{
                backgroundColor: '#1a1a1a',
                border: '2px solid gold',
                color: 'white',
                borderRadius: '5px',
                fontSize: '16px',
                padding: '12px 16px'
              }}
              autoFocus
            />
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
              <div
                onClick={() => setNewFolderPrivate(!newFolderPrivate)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  flex: 1
                }}
              >
                <input
                  type="checkbox"
                  checked={newFolderPrivate}
                  onChange={() => {}}
                  style={{
                    cursor: 'pointer',
                    width: '18px',
                    height: '18px',
                    marginRight: '8px'
                  }}
                />
                <span style={{ color: '#ddd', fontSize: '16px' }}>
                  Private Folder
                </span>
              </div>

              <button
                onClick={() => {
                  setShowNewFolderInput(false);
                  setNewFolderName('');
                  setNewFolderPrivate(false);
                }}
                style={{
                  padding: '8px 16px',
                  borderRadius: '5px',
                  color: 'white',
                  fontSize: '14px',
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  border: '1px solid white'
                }}
              >
                Cancel
              </button>

              <button
                onClick={handleCreateFolder}
                disabled={!newFolderName.trim()}
                style={{
                  padding: '8px 16px',
                  borderRadius: '5px',
                  color: 'black',
                  fontSize: '14px',
                  cursor: newFolderName.trim() ? 'pointer' : 'not-allowed',
                  backgroundColor: newFolderName.trim() ? 'gold' : '#555',
                  border: 'none',
                  fontWeight: 'bold'
                }}
              >
                Create
              </button>
            </div>
          </div>
        ) : (
          <button
            onClick={() => {
              setShowNewFolderInput(true);
              setNewFolderPrivate(activeTab === 'private');
              setActiveGameControls(null); // Clear selected game when starting to create new folder
            }}
            style={{
              width: '100%',
              padding: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'transparent',
              border: '2px solid gold',
              borderRadius: '5px',
              color: 'gold',
              fontSize: '16px',
              cursor: 'pointer',
              gap: '10px',
              fontWeight: 'bold'
            }}
          >
            <i className="fa-solid fa-plus"></i>
            Create New Folder
          </button>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user
});

export default connect(mapStateToProps)(MobileBookmarks);